import { AnyElement } from "mu-widget/lib/MuWidget";
import { BaseWidget } from "../BaseWidget";
import { BaseForm } from "./BaseForm";
import { DropdownTender } from "./DropdownTender";
import { RadioList } from "./RadioList";
import { Repeater, RepeaterItem } from "./Repeater";

export class F03_2014 extends BaseForm {
    beforeIndex(): void {
        // this.container.innerHTML = `<input type='text' mu-widget="UiPrice" />` + this.container.innerHTML;
    }
    override updateForm() {
        this.defaultVisibility();
        this.JOINT_PROCUREMENT_INVOLVED_change();
        this.validateRepeatedElements();
    }

    JOINT_PROCUREMENT_INVOLVED_change() {
        const check: HTMLInputElement = this.ui.JOINT_PROCUREMENT_INVOLVED as HTMLInputElement;

        //this.muVisible((this.ui.JOINT_PROCUREMENT_INVOLVED as HTMLInputElement).checked, "PROCUREMENT_LAW_block");
        this.hideElement(this.ui.PROCUREMENT_LAW_block, check.checked === true, false, false);

        //const addressRepeater: Repeater = this.muNamedWidget.ADDRESS_CONTRACTING_BODY as Repeater;

        //addressRepeater.maxCount = (this.ui.JOINT_PROCUREMENT_INVOLVED as HTMLInputElement).checked ? 500 : 1;
        //addressRepeater.clearItems(addressRepeater.ui.items, 0);
        //(addressRepeater.ui.bAddItem as HTMLButtonElement).disabled = (this.ui.JOINT_PROCUREMENT_INVOLVED as HTMLInputElement).checked === false    

        //this.resetText(this.ui.PROCUREMENT_LAW);
    }

    defaultVisibility() {
        this.hideElement(this.findTagElementParent(this.ui.JOINT_PROCUREMENT_INVOLVED, "div"), false);
    }

    validateRepeatedElements() {
        this.validateAllURLs();
        this.validateAllPhones();
        this.validateAllEmails();
    }

    validateAllURLs() {
        document.querySelectorAll('[type="url"]').forEach(url => this.addValidationToURL(url as HTMLInputElement));
    }

    validateAllPhones() {
        document.querySelectorAll('[mu-bind="PHONE"]').forEach(phone => this.addValidationToPhone(phone as HTMLInputElement));
        document.querySelectorAll('[mu-bind="FAX"]').forEach(phone => this.addValidationToPhone(phone as HTMLInputElement));
    }

    validateAllEmails() {
        document.querySelectorAll('[mu-bind="E_MAIL"]').forEach(email => this.addValidationToEmail(email as HTMLInputElement));
    } 

    addValidationToURL(url: HTMLInputElement) {
        url.addEventListener('input', () => {
            const val: string = url.value;

            if (this.isValidURL(val) === false) {
                this.addErrorToElement(url, "Zadejte validní URL ve tvaru - http(s)://(www.)domena.cz");
            } else {
                this.removeErrorFromElement(url);
            }
        });
    }

    addValidationToPhone(phone: HTMLInputElement) {
        phone.addEventListener('change', () => {
            const isValid: true | string = this.checkFormat(phone, "Phone");

            if (isValid !== true) {
                this.addErrorToElement(phone, isValid);
            } else {
                this.removeErrorFromElement(phone);
            }
        });
    }

    addValidationToEmail(email: HTMLInputElement) {
        email.addEventListener('change', () => {
            const isValid: true | string = this.checkFormat(email, "Email");

            if (isValid !== true) {
                this.addErrorToElement(email, isValid);
            } else {
                this.removeErrorFromElement(email);
            }
        });

    }

}


export class F03_2014_OBJECT_CONTRACT extends BaseWidget {
    repeater: Repeater;
    private cpvValidation: (event: Event) => any;
    private contractType: string = "";

    override updateForm() {
        this.VAL_TOTAL_change();
        this.TYPE_CONTRACT_change();
    }

    LOT_DIVISION_change() {
        const v: RadioList = this.muNamedWidget.LOT_DIVISION as RadioList;
        const val: string = v.muFetchData() ?? "";
        this.repeater = this.muNamedWidget.OBJECT_DESCR as Repeater;
        //const repeater2: Repeater = (document.querySelector('[mu-id="AWARD_CONTRACT"]') as AnyElement).widget as Repeater;

        //this.hideElement(document.querySelector('[mu-id="AWARD_CONTRACT"]'), val === "PT_AWARD_CONTRACT_WITHOUT_CALL", false, false);
        //this.hideElement(this.ui.DPS_ADDITIONAL_PURCHASERS_block, this.ui.DPS.checked === true && (document.querySelector('[mu-id="CENTRAL_PURCHASING"]') as HTMLInputElement).checked === true);

        this.repeater.changeMaxCount((this.muNamedWidget.LOT_DIVISION as RadioList).muFetchData() === "LOT_DIVISION" ? 1000 : 1);

        this.hideElement(this.repeater.ui.bAddItem, val === "LOT_DIVISION");
        this.repeater.muGetChildWidgets(this.repeater.ui.items).forEach(item => this.hideElement(this.findTagElementParent(item.ui.TITLE, "section"), val === "LOT_DIVISION"))
        //this.hideElement(repeater2.ui.bAddItem, val === "LOT_DIVISION");
        //this.hideElement(this.findTagElementParent(document.querySelector('[mu-id="AWARD_CONTRACT"] [mu-id="TITLE"'), 'div') as HTMLElement, val === "LOT_DIVISION");
        //this.hideElement(this.findTagElementParent(document.querySelector('[mu-id="AWARD_CONTRACT"] [mu-id="LOT_NO"'), 'div') as HTMLElement, val === "LOT_DIVISION");
        //this.hideElement(this.findTagElementParent(document.querySelector('[mu-id="AWARD_CONTRACT"] [mu-id="CONTRACT_NO"'), 'div') as HTMLElement, val !== "LOT_DIVISION");
        
    }

    VAL_TOTAL_change() {
        const val: string = (this.muNamedWidget.VAL_TOTAL as RadioList).muFetchData();

        this.hideElement(this.ui.VAL_TOTAL_block, val === "VAL_TOTAL", false, false);
        this.hideElement(this.ui.VAL_RANGE_block, val === "VAL_RANGE_TOTAL", false, false);
        this.hideElement(this.ui.VAL_RANGE_CURRENCY_frag, val === "VAL_TOTAL" || val === "VAL_RANGE_TOTAL", false, false);
    }

    VAL_TOTAL_input_input() {
        const numberInput = this.ui.VAL_TOTAL_input as HTMLInputElement;

        if (parseFloat(numberInput.value) >= 10000000000) {
            this.addErrorToElement(numberInput, "Příliš vysoká hodnota - Max (9999999999,99)");
        } else {
            this.removeErrorFromElement(numberInput);
        }
    }

    TYPE_CONTRACT_change() {
        const v: RadioList = this.muNamedWidget.TYPE_CONTRACT as RadioList;
        this.contractType = v.muFetchData() ?? "";
        this.validateAllCPVs();
        this.triggerAllCPVs();
    }

    triggerAllCPVs() {
        const ev: Event = new Event("input");

        document.querySelectorAll('[mu-bind="CPV_CODE"]').forEach(cpv => cpv.dispatchEvent(ev));
    }

    validateAllCPVs() {
        document.querySelectorAll('[mu-bind="CPV_CODE"]').forEach(cpv => this.addValidationToCPV(cpv as HTMLInputElement));
    }

    addValidationToCPV(cpv: HTMLInputElement) {
        cpv.removeEventListener('input', this.cpvValidation);
        this.cpvValidation = (event: Event) => this.validateCPV(cpv, event);
        cpv.addEventListener('input', this.cpvValidation);
    }

    validateCPV(cpv: HTMLInputElement, event: Event) {
        const val: string = cpv.value;

        if (this.validateMainCPVCode(val, this.contractType) === false && cpv.value.length > 1) {
            this.addErrorToElement(cpv, "Zadejte validní CPV pro tento typ zakázky");
        } else {
            this.removeErrorFromElement(cpv);
        }
    }


}

export class F03_2014_PROCEDURE extends BaseWidget {
    private noticeNumberErrMsg: HTMLElement | null = null;

    override afterIndex() {
        this.ACCELERATED_PROC_use_change();
        this.NOTICE_NUMBER_OJ_change();
        this.DPS_change();
        this.hideElement(document.querySelector('[mu-id="D1"]'), false);
    }

    ProcedureType_change(sender, val) {
        this.hideElement(this.findTagElementParent(this.ui.DPS, "div"), val === "PT_RESTRICTED");

        this.hideElement(this.ui.ACCELERATED_PROC_use_block, !(val === "PT_COMPETITIVE_DIALOGUE" || val === "PT_INNOVATION_PARTNERSHIP" || val === "PT_AWARD_CONTRACT_WITHOUT_CALL"), false, false);

        this.hideElement(this.ui.NOTICE_NUMBER_OJ_block, val !== "PT_AWARD_CONTRACT_WITHOUT_CALL" && val !== "none", false, true);

        this.hideElement(document.querySelector('[mu-id="D1"]'), val === "PT_AWARD_CONTRACT_WITHOUT_CALL", false, false);
        /*this.container.parentElement.widget.muNamedWidget.D1 přes mi-widget*/
    }

    ACCELERATED_PROC_use_change() {
        const rList: RadioList = this.muNamedWidget.ProcedureType as RadioList;
        /*const value: string = (this.muNamedWidget.ProcedureType as RadioList).muFetchData();*/
        const check: HTMLInputElement = this.ui.ACCELERATED_PROC_use;   

        this.hideElement(rList.ui["item-4"] as HTMLElement, check.checked === false);
        this.hideElement(rList.ui["item-5"] as HTMLElement, check.checked === false);
        this.hideElement(rList.ui["item-6"] as HTMLElement, check.checked === false);
        this.hideElement(this.ui.REASONING_PROC_block, check.checked == true, false, false);
    }

    NOTICE_NUMBER_OJ_change() {
        const el: HTMLInputElement = this.ui.NOTICE_NUMBER_OJ;

        typeof this.checkFormat(el as HTMLInputElement, "NoticeNumber") === "string" && el.value.length > 0
            ? this.addErrorToElement(el, this.checkFormat(el as HTMLInputElement, "NoticeNumber") as string)
            : this.removeErrorFromElement(el);

        this.hideElement(this.ui.TERMINATION_PIN_block, (el as HTMLInputElement).value.length > 0, false, false);
    }

    DPS_change() {
        const check: HTMLInputElement = this.ui.DPS as HTMLInputElement;
        this.hideElement(this.ui.TERMINATION_DPS_block, check.checked === true, false, false);
    }

}

export class F03_Address extends Repeater {
    override afterAddItem(widget, item) {
        this.showJointProcurement();
    }

    showJointProcurement() {
        if (this.muParent.ui.JOINT_PROCUREMENT_INVOLVED != null) {
            this.hideElement(this.findTagElementParent(this.muParent.ui.JOINT_PROCUREMENT_INVOLVED, "div"), true);
        }
    }
}

export class OBJECT_DESCR_ITEM_F03 extends RepeaterItem {
    afterIndex() {
        super.afterIndex();
        //this.OPTIONS_use_change();
        //this.AC_change();
        this.OPTIONS_change();
        this.EU_PROGR_change();
	}

    muAfterBindData(): void {
        //this.OPTIONS_use_change();
        //this.AC_change();
        this.OPTIONS_change();
        this.EU_PROGR_change();      
    }

    //OPTIONS_use_change() {
    //    const check: HTMLInputElement = this.ui.OPTIONS_use as HTMLInputElement;
    //    this.hideElement(this.ui.OPTIONS_block, check.checked === true, false, false);
    //}

    OPTIONS_change() {
        //const check: HTMLInputElement = this.ui.OPTIONS_use as HTMLInputElement;
        const v: RadioList = this.muNamedWidget.OPTIONS as RadioList;
        const val: string = v.muFetchData() ?? "";

        this.hideElement(this.ui.OPTIONS_block, val === "OPTIONS");
    }

    //AC_change() {
    //    const v: RadioList = this.muNamedWidget.AC as RadioList;
    //    const val: string = v.muFetchData() ?? "";

    //    this.hideElement(this.ui.SPECIFIC_CRITERIA as HTMLElement, val === "AC");
    //}

    EU_PROGR_change() {
        const v: RadioList = this.muNamedWidget.EU_PROGR as RadioList;
        const val: string = v.muFetchData() ?? "";

        this.hideElement(this.ui.EU_PROGR_RELATED_block, val === "EU_PROGR_RELATED" || val == null);
    }
}

export class SPECIFIC_CRITERIA extends BaseWidget {
    afterIndex(): void {
        this.muAfterBindData();
    }
    
    muAfterBindData(): void {
        this.AC_QUALITY_use_change();
        this.AC_COST_radio_change();        
    }

    AC_QUALITY_use_change() {
        this.hideElement(this.muNamedWidget.AC_QUALITY_block.container as HTMLElement, this.ui.AC_QUALITY_use.checked === true);
    }

    AC_COST_radio_change() {
        const v: RadioList = this.muNamedWidget.AC_COST_radio as RadioList;
        const val: string = v.muFetchData() ?? "";

        this.hideElement(this.muNamedWidget.AC_COST_block.container as HTMLElement, val === "AC_COST");
        this.hideElement(this.ui.AC_PRICE_block as HTMLElement, val === "AC_PRICE");
    }
}

export class AWARD_CONTRACT extends Repeater {
    tenderSelect: DropdownTender|null;

    afterIndex() {
        this.tenderSelect = this.muNamedWidget.TenderDropdown != null ? this.muNamedWidget.TenderDropdown as DropdownTender : null;
    }

    addItem(item: any = null, calledFromDropdown: boolean = false) {
        if (this.canAdd()) {
            const widget = this.muWidgetFromTemplate("item", "items");
            if (item) widget.muBindData(item);
            if (widget.ui.bRemoveItem !== null) this.hideElement(widget.ui.bRemoveItem, this.muGetChildWidgets(this.ui.items).length > this.minCount);
            if (this.ui.bAddItem !== null && this.maxCount !== null) this.hideElement(this.ui.bAddItem, this.muGetChildWidgets(this.ui.items).length < this.maxCount);
            if(calledFromDropdown === false) this.afterAddItem();
        } else alert("Nelze přidat položku");
    }

    afterAddItem() {
        if(this.tenderSelect != null)
            this.tenderSelect.addDropdownItem(true);
    }

    override muBindData(arr: any[]) {
        if (arr == null) arr = [];
        this.ui.items.innerHTML = "";
        for (let item of arr) {
            if (this.bindFieldOnly) {
                const v = item;
                item = {};
                item[this.bindFieldOnly] = v;
            }
            this.addItem(item);
        }

        if (this.tenderSelect != null) this.tenderSelect.refresh();
    }
}

export class F03_2014_AWARD_OF_CONTRACT extends RepeaterItem {
    repeater: Repeater;

    updateForm() {
        this.AWARDED_CONTRACT_change();
        this.VAL_TOTAL_AW_change();
        this.LIKELY_SUBCONTRACTED_change();
        this.PROCUREMENT_REASON_change();
    }

    beforeRemove() {
        const parent: AWARD_CONTRACT = this.muParent as AWARD_CONTRACT;

        if (parent.tenderSelect != null) {
            const pattern = /^Zakázka (\d{1,4})$/;
            const index = parent.tenderSelect.allTenders.indexOf(this.container as HTMLElement);
            parent.tenderSelect.allItems.filter(el => pattern.test(el.innerText)).forEach(el => {
                const ogNum = parseInt(el.innerText.split(" ")[1], 10);
                if (ogNum > index + 1)
                    (el.firstElementChild as HTMLElement).innerText = el.innerText.replace("" + ogNum, "" + (ogNum - 1));
            })

            parent.tenderSelect.removeItem(parent.tenderSelect.allTenders.indexOf(this.container as HTMLElement));
        }
    }

    CONTRACT_NO_change() {
        const parent: AWARD_CONTRACT = this.muParent as AWARD_CONTRACT;

        if (parent.tenderSelect != null) {
            if (((this.ui.CONTRACT_NO as HTMLInputElement).value ?? "").length > 0) {
                parent.tenderSelect.changeLabel(parent.tenderSelect.allTenders.indexOf(this.container as HTMLElement), "Zakázka č. " + this.ui.CONTRACT_NO.value);
                if (parent.tenderSelect.allItems[parent.tenderSelect.allTenders.indexOf(this.container as HTMLElement)].firstElementChild.classList.contains("active"))
                    parent.tenderSelect.ui.bTenders.innerText = "Zakázka č. " + this.ui.CONTRACT_NO.value;
            }
            else
                parent.tenderSelect.changeLabel(parent.tenderSelect.allTenders.indexOf(this.container as HTMLElement));
                if (parent.tenderSelect.allItems[parent.tenderSelect.allTenders.indexOf(this.container as HTMLElement)].firstElementChild.classList.contains("active"))
                    parent.tenderSelect.ui.bTenders.innerText = (parent.tenderSelect.allItems[parent.tenderSelect.allTenders.indexOf(this.container as HTMLElement)].firstElementChild as HTMLElement).innerText;
        }
    }

    AWARDED_CONTRACT_change() {
        const v: RadioList = this.muNamedWidget.AWARDED_CONTRACT as RadioList;
        const val: string = v.muFetchData() ?? "";

        this.hideElement(this.ui.AWARDED_block, val === "AWARDED_CONTRACT" || val == null, false);
        this.hideElement(this.ui.NO_AWARDED_block, val === "NO_AWARDED_CONTRACT" || val == null, false);
    }

    PROCUREMENT_REASON_change() {
        const v: RadioList = this.muNamedWidget.PROCUREMENT_REASON as RadioList;
        const val: string = v.muFetchData() ?? "";

        this.hideElement(this.ui.PROCUREMENT_REASON_block, val === "PROCUREMENT_DISCONTINUED", false, true);
        /*this.hideElement(this.ui.NO_AWARDED_block, val === "NO_AWARDED_CONTRACT" || val == null, false, false);*/
    }

    AWARDED_TO_GROUP_change() {
        this.repeater = this.muNamedWidget.ADDRESS_CONTRACTOR as Repeater;
        this.repeater.changeMinCount((this.muNamedWidget.AWARDED_TO_GROUP as RadioList).muFetchData() === "AWARDED_TO_GROUP" ? 2 : 1);

        while (this.repeater.minCount > (this.repeater.ui.items as HTMLElement).childElementCount)
        {
            this.repeater.addItem();
        }
    }

    NB_TENDERS_RECEIVED_input() {
        const numberInput = this.ui.NB_TENDERS_RECEIVED as HTMLInputElement;

        if (parseInt(numberInput.value) >= 1000) {
            this.addErrorToElement(numberInput, "Příliš vysoká hodnota - Max (999)");
        } else {
            this.removeErrorFromElement(numberInput);
        }
    }

    NB_TENDERS_RECEIVED_SME_input() {
        const numberInput = this.ui.NB_TENDERS_RECEIVED_SME as HTMLInputElement;

        if (parseInt(numberInput.value) >= 1000) {
            this.addErrorToElement(numberInput, "Příliš vysoká hodnota - Max (999)");
        } else {
            this.removeErrorFromElement(numberInput);
        }
    }

    NB_TENDERS_RECEIVED_OTHER_EU_input() {
        const numberInput = this.ui.NB_TENDERS_RECEIVED_OTHER_EU as HTMLInputElement;

        if (parseInt(numberInput.value) >= 1000) {
            this.addErrorToElement(numberInput, "Příliš vysoká hodnota - Max (999)");
        } else {
            this.removeErrorFromElement(numberInput);
        }
    }

    NB_TENDERS_RECEIVED_NON_EU_input() {
        const numberInput = this.ui.NB_TENDERS_RECEIVED_NON_EU as HTMLInputElement;

        if (parseInt(numberInput.value) >= 1000) {
            this.addErrorToElement(numberInput, "Příliš vysoká hodnota - Max (999)");
        } else {
            this.removeErrorFromElement(numberInput);
        }
    }

    NB_TENDERS_RECEIVED_EMEANS_input() {
        const numberInput = this.ui.NB_TENDERS_RECEIVED_EMEANS as HTMLInputElement;

        if (parseInt(numberInput.value) >= 1000) {
            this.addErrorToElement(numberInput, "Příliš vysoká hodnota - Max (999)");
        } else {
            this.removeErrorFromElement(numberInput);
        }
    }

    VAL_TOTAL_AW_change() {
        const v: RadioList = this.muNamedWidget.VAL_TOTAL_AW as RadioList;
        const val: string = v.muFetchData() ?? "";

        this.hideElement(this.ui.VAL_TOTAL_AW_block, val === "VAL_TOTAL" || val == null, false);
        this.hideElement(this.ui.VAL_RANGE_TOTAL_AW_block, val === "VAL_RANGE_TOTAL" || val == null, false);
    }

    VAL_ESTIMATED_TOTAL_input_input() {
        const numberInput = this.ui.VAL_ESTIMATED_TOTAL_input as HTMLInputElement;

        if (parseFloat(numberInput.value) >= 10000000000) {
            this.addErrorToElement(numberInput, "Příliš vysoká hodnota - Max (9999999999,99)");
        } else {
            this.removeErrorFromElement(numberInput);
        }
    }

    LIKELY_SUBCONTRACTED_change() {
        const check: HTMLInputElement = this.ui.LIKELY_SUBCONTRACTED as HTMLInputElement;
        this.hideElement(this.ui.LIKELY_SUBCONTRACTED_block, check.checked === true, false);
    }

    VAL_TOTAL_SUM_input() {
        const numberInput = this.ui.VAL_TOTAL_SUM as HTMLInputElement;

        if (parseFloat(numberInput.value) >= 10000000000) {
            this.addErrorToElement(numberInput, "Příliš vysoká hodnota - Max (9999999999,99)");
        } else {
            this.removeErrorFromElement(numberInput);
        }
    }

    VAL_RANGE_TOTAL_LOW_input() {
        const numberInput = this.ui.VAL_RANGE_TOTAL_LOW as HTMLInputElement;

        if (parseFloat(numberInput.value) >= 10000000000) {
            this.addErrorToElement(numberInput, "Příliš vysoká hodnota - Max (9999999999,99)");
        } else {
            this.removeErrorFromElement(numberInput);
        }
    }

    VAL_RANGE_TOTAL_HIGH_input() {
        const numberInput = this.ui.VAL_RANGE_TOTAL_HIGH as HTMLInputElement;

        if (parseFloat(numberInput.value) >= 10000000000) {
            this.addErrorToElement(numberInput, "Příliš vysoká hodnota - Max (9999999999,99)");
        } else {
            this.removeErrorFromElement(numberInput);
        }
    }

    VAL_SUBCONTRACTING_input() {
        const numberInput = this.ui.VAL_SUBCONTRACTING as HTMLInputElement;

        if (parseFloat(numberInput.value) >= 10000000000) {
            this.addErrorToElement(numberInput, "Příliš vysoká hodnota - Max (9999999999,99)");
        } else {
            this.removeErrorFromElement(numberInput);
        }
    }

    VAL_SUBCONTRACTING_change() {
        const el: HTMLInputElement = this.ui.VAL_SUBCONTRACTING;
        this.hideElement(this.ui.PCT_SUBCONTRACTING_block, (el as HTMLInputElement).value.length == 0 || parseFloat((el as HTMLInputElement).value.replace(',', '')) == 0, false, true);
    }

    PCT_SUBCONTRACTING_change() {
        const el: HTMLInputElement = this.ui.PCT_SUBCONTRACTING;
        this.hideElement(this.ui.VAL_SUBCONTRACTING_block, (el as HTMLInputElement).value.length == 0, false, true);
    }

}

export class DateWidget extends BaseWidget {
    override afterIndex() {
        this.ui.DATE_DISPATCH_NOTICE.innerText = new Date().toLocaleDateString("cs-CZ", { day: '2-digit', month: '2-digit', year: 'numeric' });
    }
}
   
export class F03_2014_CURRENCY extends BaseWidget {
}

export class F03_2014_CURRENCY2 extends BaseWidget {
    override muBindData(src) {
        super.muBindData({VALUE: src});
    }

    override muFetchData() {
        return super.muFetchData().VALUE;
    }
}

export class F03_2014_CURRENCY3 extends BaseWidget {
}

export class D1 extends BaseWidget {
    override afterIndex() {
        this.D_JUSTIFY_change();
    }

    D_JUSTIFY_change() {
        const v: RadioList = this.muNamedWidget.D_JUSTIFY as RadioList;
        const val: string = v.muFetchData() ?? "";

        this.hideElement(this.ui.D_ACCORDANCE_ARTICLE_block, val === "D_ACCORDANCE_ARTICLE" || val == null, false, false);
        /*this.hideElement(this.ui.D_OUTSIDE_SCOPE_block, val === "D_OUTSIDE_SCOPE" || val == null, false, false);*/
    } 
    
}

export class F03_COMPLEMENTARY_INFO extends BaseWidget {
    override afterIndex() {
        this.prefillSelects();
    }

    prefillSelects() {
        this.container.querySelectorAll('select[mu-id="COUNTRY"]').forEach(s => (s as HTMLSelectElement).selectedIndex = 1)
    }

}